import { hasValue } from '../general-helpers';
import { ensureValidUri } from './url-utils';

export function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    // eslint-disable-next-line no-useless-escape
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export const removeParameterByName = (name) => {
    if (!hasValue(name)) {
        return;
    }

    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);
    params.delete(name);
    url.search = params.toString();
    window.history.replaceState({}, '', url);
};

export const addQueryParam = (url = '', key = '', value = '') => {
    if (!hasValue(url) || !hasValue(key) || !hasValue(value)) {
        return undefined;
    }

    const urlObject = new URL(url);

    urlObject.searchParams.set(key, value);

    const modifiedUrl = urlObject.toString();

    return modifiedUrl;
};

export const addQueryParams = (url = '', params = []) => {
    if (!url || !hasValue(params)) {
        return url;
    }

    url = ensureValidUri(url);

    // eslint-disable-next-line no-unused-expressions
    params.forEach((param) => {
        const modifiedUrl = addQueryParam(url, param.key, param.value);

        url = hasValue(modifiedUrl) ? modifiedUrl : url;
    });

    return url;
};
